import { PRODUCT_SOURCES } from '@/config/products'

import { clAdapter } from './cl'
import { lpAdapter } from './lp'

export const getAdapter = source => {
  switch (source) {
    case PRODUCT_SOURCES.CL:
      return clAdapter
    case PRODUCT_SOURCES.LP:
      return lpAdapter
    default: {
      const unknown = source
      throw new Error(`Unsupported product source: ${unknown}`)
    }
  }
}
